/* eslint-disable react/jsx-wrap-multilines */
import Text from '@deprecated-ui/common/Text';
import Iconmoon, { IconWrapper } from '@deprecated-ui/common/Iconmoon';
import Tooltip from '@deprecated-ui/common/Tooltip';
import Input from '@deprecated-ui/common/Input';
import { SITE_URL } from 'constants/api';
import { copyTextToClipboard } from 'utils/general';
import { Modal } from './styled';

interface ModalLinkPostProps {
  postid: number;
  [key: string]: any;
}

function ModalLinkPost({ postid, ...props }: ModalLinkPostProps) {
  const linkUrl = `${SITE_URL}/post/${postid}`;

  const copyLink = () => {
    copyTextToClipboard(linkUrl);
  };

  return (
    <Modal
      {...props}
      title={
        <Text size="16px" height="40px" weight="bold">
          Post Url
        </Text>
      }
      centered
      width={380}
      footer={null}
    >
      <Text size="12px">Copy and paste this link to share this post </Text>
      <Input
        width="100%"
        value={linkUrl}
        style={{ margin: '5px 0' }}
        suffix={
          <Tooltip title="Copy to clipboard">
            <IconWrapper onClick={copyLink}>
              <Iconmoon className="icon-toolbar_copy" />
            </IconWrapper>
          </Tooltip>
        }
      />
    </Modal>
  );
}

export default ModalLinkPost;
